/**
 * Originally copied from https://snack.expo.dev/@bgpiggin/accordion-list
 */
import React, { useState, useRef, useEffect } from 'react'
import {
  View,
  StyleSheet,
  Animated,
  Easing,
  TextStyle,
  StyleProp,
  ViewStyle
} from 'react-native'

type Props = {
  title: React.ReactElement;
  children: React.ReactElement | React.ReactElement[];
  expanded?: boolean;
  titleStyle?: StyleProp<TextStyle>;
  wrapStyle?: StyleProp<ViewStyle>;
}

const AccordionListItem: React.FC<Props> = ({
  title,
  children,
  expanded,
  wrapStyle,
  titleStyle
}: Props) => {
  const animatedController = useRef(new Animated.Value(expanded ? 1 : 0)).current
  const [bodySectionHeight, setBodySectionHeight] = useState(1)

  // On web, it's important to prevent layout shift on initial render, so we
  // use refs to detect the change and conditionally apply the styled needed for animation.
  // this is mostly only a problem if the initial state is expanded
  const [hasToggled, setHasToggled] = useState(!expanded)
  const expandedRef = useRef(expanded)

  const bodyHeight = animatedController.interpolate({
    inputRange: [0, 1],
    outputRange: [0, bodySectionHeight],
  })

  // const arrowAngle = animatedController.interpolate({
  //   inputRange: [0, 1],
  //   outputRange: ['0rad', `${Math.PI}rad`],
  // })

  useEffect(() => {
    if (hasToggled) {
      if (expanded) {
        Animated.timing(animatedController, {
          duration: 1000,
          toValue: 1,
          easing: Easing.bezier(0.4, 0.0, 0.2, 1),
          useNativeDriver: false
        }).start()
      } else {
        Animated.timing(animatedController, {
          duration: 1000,
          toValue: 0,
          easing: Easing.bezier(0.4, 0.0, 0.2, 1),
          useNativeDriver: false
        }).start()
      }

      expandedRef.current = expanded
    }
  }, [expanded, hasToggled, animatedController])

  useEffect(() => {
    if (expanded !== expandedRef.current) {
      setHasToggled(true)
    }
  }, [expanded])

  return (
    <View style={wrapStyle} accessibilityRole='adjustable'>
      <View style={[styles.titleContainer, titleStyle]}>
        {title}
        {/* <Animated.View style={{ transform: [{ rotateZ: arrowAngle }] }}>
            <MaterialIcons name="keyboard-arrow-down" size={20} color="black" />
          </Animated.View> */}
      </View>
      <Animated.View style={[styles.bodyBackground, hasToggled ? { height: bodyHeight } : {}]}>
        <View
          style={[styles.bodyContainer, hasToggled ? styles.initializedBodyContainer : {}]}
          onLayout={event => {
            setBodySectionHeight(event.nativeEvent.layout.height)
          }}
        >
          {children}
        </View>
      </Animated.View>
    </View>
  )
}
export default AccordionListItem

const styles = StyleSheet.create({
  bodyBackground: {
    overflow: 'hidden',
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  bodyContainer: {
    padding: 1,
    paddingLeft: 1.5,
  },
  initializedBodyContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
  }
})
